var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('WBase',{staticClass:"webjet-audio"},[_c('WHeader',{attrs:{"icon":_vm.icon}}),_c('WExpand',[_c('WContent',[_c('WUploader'),_c('audio',{attrs:{"src":_vm.url,"controls":"","preload":"metadata"}}),_c('WChilds')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }